import React, { useRef } from 'react';
import { Sparkles } from 'lucide-react';
import profileImage from '../../images/profile-new.mp4';
import styles from './GraphicDesignAboutMe.module.css';
import Experience from '../Experience/Experience';



const GraphicDesignAboutMe = () => {
  const ref = useRef(null);
  return (
    <section id="about" className={styles.aboutSection}>
      {/* Animated Background Elements for About Section */}
      <div className={styles.aboutBgElements}>
        <div className={styles.aboutBlob1}></div>
        <div className={styles.aboutBlob2}></div>
        <div className={styles.aboutBlob3}></div>
      </div>

      {/* Animated Grid Lines */}
      <div className={styles.gridLines}>
        <div className={styles.gridLineVertical1}></div>
        <div className={styles.gridLineVertical2}></div>
        <div className={styles.gridLineVertical3}></div>
        <div className={styles.gridLineHorizontal1}></div>
        <div className={styles.gridLineHorizontal2}></div>
      </div>

      {/* Floating Geometric Shapes */}
      <div className={styles.geometricShapes}>
        <div className={styles.geoShape1}></div>
        <div className={styles.geoShape2}></div>
        <div className={styles.geoShape3}></div>
        <div className={styles.geoShape4}></div>
        <div className={styles.geoShape5}></div>
        <div className={styles.geoShape6}></div>
      </div>

      {/* Floating Particles */}
      <div className={styles.particlesContainer}>
        {[...Array(15)].map((_, i) => (
          <div key={i} className={`${styles.particle} ${styles[`particle${i + 1}`]}`}></div>
        ))}
      </div>

      {/* Light Rays */}
      <div className={styles.lightRays}>
        <div className={styles.ray1}></div>
        <div className={styles.ray2}></div>
        <div className={styles.ray3}></div>
      </div>

      <div className={styles.aboutContainer}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionLabel}>Who I Am</span>
          <h2 className={styles.sectionTitle}>About Me</h2>
          <div className={styles.titleUnderline}></div>
        </div>

        <div className={styles.aboutGrid}>
          <div className={styles.profileSide}>
            <div className={styles.profileContainer}>
              <div className={styles.profileImageWrapper}>
                <div className={styles.profileImageHolder}>
                  <video
                    src={profileImage}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className={styles.profileImageStatic}
                  />
                  <div className={styles.hoverOverlay}>
                    <span className={styles.hoverText}>Hover Me!</span>
                  </div>
                </div>
                <div className={styles.profileRing1}></div>
                <div className={styles.profileRing2}></div>
                <div className={styles.profileRing3}></div>
                <div className={styles.profileDot1}></div>
                <div className={styles.profileDot2}></div>
                <div className={styles.profileDot3}></div>
              </div>

              <div className={styles.funFactCard}>
                <Sparkles size={16} className={styles.funFactIcon} />
                <p className={styles.funFactText}>Obsessed with colors & typography</p>
              </div>
            </div>
          </div>

          <div className={styles.contentSide}>
            <div className={styles.aboutContent}>
              <h3 className={styles.aboutHeading}>
                Designer, Illustrator & Creative Enthusiast
              </h3>

              <div className={styles.aboutText}>
                <p className={styles.paragraph}>
                  Hey there! I'm a passionate graphic designer and illustrator who believes
                  that every visual tells a story. With a keen eye for detail and a love for
                  bold, expressive designs, I create work that not only looks beautiful but
                  also communicates powerful messages.
                </p>

               
              </div>

             

            </div>
            
          </div>
          
        </div>
         <div className={styles.skillsContainer}>
           <p className={styles.paragraph}>
                  My journey in design started with a simple sketchbook and has evolved into
                  a full-blown love affair with colors, shapes, and visual narratives. I
                  specialize in illustration, branding, and creating memorable visual identities
                  that help brands stand out.
                </p>

                <p className={styles.paragraph}>
                  When I'm not pushing pixels or sketching ideas, you'll find me exploring
                  art galleries, reading comics, or hunting for inspiration in everyday moments.
                </p>
                
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>🎨</span>
                  Adobe Animate
                </span>
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>✨</span>
                  After Effects
                </span>
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>🖌️</span>
                  Procreate App
                </span>
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>📸</span>
                  Adobe Photoshop
                </span>
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>📄</span>
                  Adobe InDesign
                </span>
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>🎭</span>
                  Adobe Illustrator
                </span>
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>🎬</span>
                  Adobe Premiere Pro
                </span>
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>🖼️</span>
                  Vector Illustration
                </span>
                <span className={styles.skillTag}>
                  <span className={styles.skillIcon}>🎥</span>
                  Motion Graphics
                </span>
              </div>
      </div>

      <Experience />
    </section>
  );
};

export default GraphicDesignAboutMe;